.wrapper--small {
  width: var(--rc-theme-react-components-attachment-input-file-width-small);
}

.shrink {
  min-width: 0;
  overflow: hidden;
}
